import qs from 'qs';
import fileDownload from 'react-file-download';
import moment from 'moment';
import _ from 'underscore';
import request from 'superagent';

import AdminServerActionCreators from 'actions/AdminServerActionCreators';
import ToastStore, { showToast } from 'stores/ToastStore';
import i18next from 'i18next';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';
import client from './rest/AdminClient';
import ServerActions from '../actions/AdminServerActionCreators';
import SessionStore from '../stores/SessionStore';

function get(id) {
  return client({
    method: 'GET',
    path: `api/1/users/${id}`,
  });
}

export function exportUsersCsv(cols, filters = []) {
  const query = _.extend({}, filters);
  query.columns = cols;
  const queryString = qs.stringify(query);
  return client({
    method: 'POST',
    path: '/api/v2/users/csv-from-query?' + queryString,
  });
}

export function findAssociatedAccounts(query, context) {
  const queryString = qs.stringify(query);
  return client({
    method: 'GET',
    path: `/api/v3/users/associated?context=${context}&${queryString}`,
  });
}

export function getEmptyReturnInstructions() {
  return client({
    method: 'GET',
    path: `/instructions/empty-return`,
  });
}

export function findUsers(query) {
  const queryString = qs.stringify(query);
  return client({
    method: 'GET',
    path: '/admin/api/v3/users?' + queryString,
  });
}

/**
 * @param {Array} userIdsArray
 * This function is used for querying for an array of customer IDs too large for the above GET request to handle
 */
export function findManyUsers(userIdsArray) {
  return client({
    method: 'POST',
    path: '/admin/api/v3/users',
    entity: JSON.stringify(userIdsArray),
  });
}

export async function createWarehouseWithAssociations(payload) {
  const result = await client({
    method: 'POST',
    path: '/admin/api/v2/warehouse/shipper-relation',
    entity: JSON.stringify(payload),
  });

  return result.entity;
}
export async function getWarehousesWithAssociation() {
  const result = await client({
    method: 'GET',
    path: '/admin/api/v2/warehouse/shipper-relation?limit=200&skip=0',
  });

  return result.entity?.data;
}

export async function deleteWarehouseWithAsssociation(warehouseId) {
  const result = await client({
    method: 'DELETE',
    path: `/admin/api/v2/warehouse/${warehouseId}/remove-warehouse`,
  });

  return result.entity;
}

export async function deleteShipperWithAssosciation({
  warehouseId,
  shipperId,
}) {
  const result = await client({
    method: 'DELETE',
    path: `/admin/api/v2/warehouse/${warehouseId}/remove-shippers/${shipperId}`,
  });

  return result.entity;
}

export async function findThirdPartyCarriers(query) {
  try {
    const queryString = qs.stringify(query);
    const result = await client({
      method: 'GET',
      path: '/api/v2/users/carriers/third-party?' + queryString,
    });
    return result.entity.data.items;
  } catch (e) {
    showToast(
      i18next.t('GET_THIRD_PARTY_CARRIERS'),
      i18next.t('GET_CARRIERS_WITH_ERROR', { error: e.entity.error }),
      'error',
    );
    return [];
  }
}

function deactivateUsers(users, params) {
  const payload = { ids: users, params };
  return client({
    method: 'POST',
    path: '/admin/api/v2/users/admin/deactivate',
    entity: JSON.stringify(payload),
  });
}

function activateUsers(users, params) {
  const payload = { ids: users, params };
  return client({
    method: 'POST',
    path: '/admin/api/v2/users/admin/activate',
    entity: JSON.stringify(payload),
  });
}

function updateUsersRoles(users, params) {
  const payload = { users, params };
  return client({
    method: 'POST',
    path: '/admin/api/v2/users/admin/users/roles',
    entity: JSON.stringify(payload),
  });
}

export function getAdminUsers(query) {
  const queryString = qs.stringify(query);
  return client({
    method: 'GET',
    path: `/admin/api/v3/internal/users?${queryString}`,
  });
}

export function getUserContextGrants(contexts = []) {
  return client({
    method: 'GET',
    path: `/api/v2/scopes?context=${contexts.join(',')}`,
  });
}

function getUserContextGrantsByGrantee(grantorId, contexts = []) {
  return client({
    method: 'GET',
    path: `/admin/api/v2/scopes/granted-by/${grantorId}?context=${contexts.join(
      ',',
    )}`,
  });
}

function getCustomers(params, options) {
  const payload = { params, options };
  return client({
    method: 'POST',
    path: `/admin/api/customers/stream`,
    entity: JSON.stringify(payload),
  });
}

function downloadCustomersCsv(params, options) {
  const payload = { params, options };

  return client({
    method: 'POST',
    path: `/admin/api/customers/csv`,
    entity: JSON.stringify(payload),
  });
}

function addAdminUser(user) {
  return client({
    method: 'POST',
    path: '/admin/v2/users',
    entity: JSON.stringify(user),
  });
}

const updateContacts = (id, contacts) => {
  return client({
    method: 'POST',
    path: `api/v2/users/${id}/contacts`,
    entity: JSON.stringify({ contacts }),
  });
};

const updateRoutingConfiguration = (shipperId, routingConfiguration) => {
  return client({
    method: 'PATCH',
    path: `/api/v2/shippers/${shipperId}/routing`,
    entity: JSON.stringify({ routingConfiguration }),
  });
};

const retrieveRoutingConfiguration = (shipperId) => {
  return client({
    method: 'GET',
    path: `/api/v2/shippers/${shipperId}/routing`,
  });
};

function addCargomaticUser(user) {
  return client({
    method: 'POST',
    path: 'api/1/shippers',
    entity: JSON.stringify(user),
  });
}

function addCarrier(carrier) {
  return client({
    method: 'POST',
    path: '/api/1/carriers',
    entity: JSON.stringify(carrier),
  });
}

export function addConsignee(consignee) {
  return client({
    method: 'POST',
    path: '/api/1/consignees',
    entity: JSON.stringify(consignee),
  });
}
export function addWarehouseUser(warehouseUser) {
  return client({
    method: 'POST',
    path: '/admin/api/v3/users/warehouse',
    entity: JSON.stringify(warehouseUser),
  });
}

function addVendor(vendor) {
  return client({
    method: 'POST',
    path: '/api/1/vendors',
    entity: JSON.stringify(vendor),
  });
}

function addDriver(driver) {
  return client({
    method: 'POST',
    path: `api/1/carriers/${driver.carrier}/driver`,
    entity: JSON.stringify(driver),
  });
}

function update(id, atts) {
  return client({
    method: 'PATCH',
    path: `api/1/drivers/${id}`,
    entity: JSON.stringify(atts),
  });
}

function updateNotificationEvent(id, data) {
  return client({
    method: 'PUT',
    path: `api/1/users/${id}/notifications/events`,
    entity: JSON.stringify(data),
  });
}

function updateNotificationRecipients(id, data) {
  return client({
    method: 'PUT',
    path: `api/1/users/${id}/notifications/recipients`,
    entity: JSON.stringify(data),
  });
}

export function getWebhooks(account) {
  return client({
    method: 'GET',
    path: `api/notifications/webhooks?account=${account}&_=${Date.now()}`,
  });
}

export function createWebhook(webhook) {
  return client({
    method: 'POST',
    path: 'api/notifications/webhooks',
    entity: JSON.stringify(webhook),
  });
}

export function updateWebhook(updates) {
  return client({
    method: 'PATCH',
    path: `api/notifications/webhooks/${updates._id}`,
    entity: JSON.stringify(updates),
  });
}

export function deleteWebhook(id) {
  return client({
    method: 'DELETE',
    path: `api/notifications/webhooks/${id}`,
  });
}

export function bulkRegisterUsers(file, emailIds) {
  return new Promise((resolve, reject) => {
    const req = request.post(`${API_HOST}/admin/api/v3/users/bulk`);
    req.set('Authorization', getBearerGrantTypeAuthHeaders());
    req.field('emails', JSON.stringify(emailIds));
    req.attach('bulk-user-creation', file);

    req.end((err, response) => {
      if (err) {
        if (response.type === 'application/json') {
          showToast('', i18next.t(response.body.error), 'error');
        }
        return reject(err);
      }
      showToast(
        i18next.t('BULK_USER'),
        i18next.t('BULK_USER_SUCCESS_MSG'),
        'success',
      );
      resolve(response);
    });
  });
}

export function uploadBulkConsigneeCSVFile(file) {
  return new Promise((resolve, reject) => {
    const req = request.post(`${API_HOST}/admin/api/v3/users/consignees/bulk`);
    req.set('Authorization', getBearerGrantTypeAuthHeaders());
    req.attach('file', file);

    req.end((err, response) => {
      if (err) {
        if (response.type === 'application/json') {
          showToast(
            i18next.t('BULK_CONSIGNEE'),
            i18next.t('BULK_CONSIGNEE_CSV_ERROR', {
              error: response.body.error,
            }),
            'error',
          );
          return reject(response.body.error);
        }
        return reject(err);
      }

      showToast(
        i18next.t('BULK_CONSIGNEE'),
        i18next.t('BULK_CONSIGNEE_SUCCESS_MSG'),
        'success',
      );
      fileDownload(response.text, 'consignees.csv');

      resolve();
    });
  });
}

function getAPIKeys(userId) {
  return client({
    method: 'GET',
    path: `api/v2/user/api-key?${qs.stringify({ userId })}`,
  });
}

function generateAPIKey(userId) {
  return client({
    method: 'POST',
    path: `api/v2/user/api-key`,
    entity: JSON.stringify({ userId }),
  });
}

function getAccountAccessRequests(userId) {
  return client({
    method: 'POST',
    path: `api/1/users/access/requests`,
    entity: JSON.stringify({ grantee: userId, grantor: userId }),
  });
}
function createAccountAccessRequest(userId, emails) {
  return client({
    method: 'POST',
    path: `api/1/users/${userId}/access/request`,
    entity: JSON.stringify({ emails }),
  });
}

function createGrants(grantorId, granteeId, role, _type, userType) {
  return client({
    method: 'POST',
    path: `/api/1/users/grants/create`,
    entity: JSON.stringify({
      grantorId,
      granteeId,
      role,
      _type,
      userType,
    }),
  });
}

export function generateSensitiveDocumentLinks(carrier_id) {
  return client({
    method: 'GET',
    path: `/admin/api/v2/users/${carrier_id}/get-sensitive-documents`,
  });
}

export function generateStripeIdentityDocumentLinks(sessionId) {
  return client({
    method: 'POST',
    path: `/api/v2/users/verification-session/retrieve`,
    entity: JSON.stringify({ sessionId }),
  });
}

function revokeAdminPermission(
  grantorId,
  granteeId,
  role,
  _type,
  userType,
  revokeDate,
) {
  return client({
    method: 'POST',
    path: `/api/1/users/grants/revoke`,
    entity: JSON.stringify({
      grantorId,
      granteeId,
      role,
      _type,
      userType,
      revokeDate,
    }),
  });
}

function createSupportRequest(userId, email, grantorId) {
  return client({
    method: 'POST',
    path: `admin/api/v2/users/${userId}/support/request`,
    entity: JSON.stringify({ email, grantorId }),
  });
}

function linkAccountAccessRequest(userId, requestId) {
  return client({
    method: 'POST',
    path: `api/1/users/${userId}/access/requests/linkAccounts`,
    entity: JSON.stringify({ requestId }),
  });
}

function createSupportRequestGrant(userId, jwt) {
  console.log('Sending userId ', userId);
  console.log('Sending jwt ', jwt);
  return client({
    method: 'POST',
    path: `api/1/users/${userId}/support/request/createGrant`,
    entity: JSON.stringify({ jwt }),
  });
}

function updateBankingInfoStatus(
  carrierId,
  stripe_verified_documents,
  all_banking_info_approved,
  admin_banking_info_remark,
) {
  return client({
    method: 'POST',
    path: `/admin/api/v2/review/${carrierId}/banking_info`,
    entity: JSON.stringify({
      carrierId,
      stripe_verified_documents,
      all_banking_info_approved,
      admin_banking_info_remark,
    }),
  });
}

function loginAs(userId, grantorId) {
  return client({
    method: 'POST',
    path: `admin/api/v2/users/${userId}/support/loginAs`,
    entity: JSON.stringify({ grantorId }),
  });
}

function findCarriers(query) {
  const queryString = qs.stringify(query);
  return client({
    method: 'GET',
    path: '/api/1/carriers?' + queryString,
  });
}

export default {
  get(id) {
    const success = (res) => {
      ServerActions.receiveUserSuccess(res.entity);
    };
    const fail = (err) => {
      console.error('ERROR', err);
    };
    get(id).then(success, fail);
  },

  async linkAccountAccessRequest(userId, requestId) {
    return linkAccountAccessRequest(userId, requestId)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        showToast(
          i18next.t('ACCOUNT_ACCESS'),
          i18next.t('ACCOUNT_PERMISSIONS_ERROR', { error: e.message }),
          'error',
        );
        throw e;
      });
  },

  async getV2(id) {
    return get(id)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        throw e;
      });
  },

  async updateContacts(id, contacts) {
    return updateContacts(id, contacts)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        throw e;
      });
  },

  async retrieveRoutingConfiguration(shipperId) {
    return retrieveRoutingConfiguration(shipperId)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        throw e;
      });
  },

  async updateRoutingConfiguration(shipperId, routingConfiguration) {
    return updateRoutingConfiguration(shipperId, routingConfiguration)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        throw e;
      });
  },

  async generateAPIKey(userId) {
    return generateAPIKey(userId)
      .then((result) => {
        showToast(
          i18next.t('API_KEY'),
          i18next.t('GENERATED_API_KEY_SUCCESSFULLY'),
        );
        return result.entity;
      })
      .catch((e) => {
        showToast(
          i18next.t('API_KEY'),
          i18next.t('ERROR_GENERATING_API_KEY'),
          'error',
        );
        throw e;
      });
  },

  async getAPIKeys(shipperId) {
    return getAPIKeys(shipperId)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        showToast(
          i18next.t('API_KEY'),
          i18next.t('API_KEY_RETRIEVAL_ERROR'),
          'error',
        );
        throw e;
      });
  },

  async updateDriverEquipment(id, driverUpdate) {
    return update(id, driverUpdate)
      .then((result) => {
        showToast(
          i18next.t('DRIVER_EQUIPMENT'),
          i18next.t('DRIVER_UPDATE_SUCCESS'),
        );
        return result.entity;
      })
      .catch((e) => {
        showToast(
          i18next.t('DRIVER_EQUIPMENT'),
          i18next.t('DRIVER_UPDATE_FAILED_ERROR', { error: e.message }),
          'error',
        );
        throw e;
      });
  },

  async getManagedCustomers(incomingQuery) {
    const query = _.extend(
      {},
      {
        select: '_id company_name',
        per_page: 500,
        page: 1,
      },
      incomingQuery,
    );

    const response = await findUsers(query).catch(() => {
      return null;
    });

    if (response) {
      return response.entity.items;
    }
    return [];
  },

  findUsers(query) {
    findUsers(query).then(
      (res) => {
        AdminServerActionCreators.receiveCustomers(res.entity);
      },
      (err) => {
        console.log('Failed to get customers', err);
      },
    );
  },

  deactivateUsers(users, params) {
    deactivateUsers(users, params).then(
      (response) => {
        AdminServerActionCreators.receiveAdminUsers(response.entity.data);
      },
      (err) => {
        console.log('Failed to get admin users:', err);
      },
    );
  },

  activateUsers(users, params) {
    activateUsers(users, params).then(
      (response) => {
        AdminServerActionCreators.receiveAdminUsers(response.entity.data);
      },
      (err) => {
        console.log('Failed to get admin users:', err);
      },
    );
  },

  updateUsersRoles(users, params) {
    updateUsersRoles(users, params).then(
      (response) => {
        AdminServerActionCreators.receiveAdminUsers(response.entity.data);
      },
      (err) => {
        console.log('Failed to get admin users:', err);
      },
    );
  },

  getSalesReps(query) {
    getAdminUsers(query).then(
      (response) => {
        AdminServerActionCreators.receiveSalespeople(response.entity.data);
      },
      (err) => {
        console.error('GET Sales Users ERROR: ', err);
      },
    );
  },

  getAdminUsers(query) {
    getAdminUsers(query).then(
      (response) => {
        AdminServerActionCreators.receiveAdminUsers(response.entity.data);
      },
      (err) => {
        console.error('GET Admin Users ERROR: ', err);
      },
    );
  },

  addAdminUser(user) {
    addAdminUser(user).then(
      (response) => {
        AdminServerActionCreators.receiveAdminUser(response.entity.data);
      },
      (err) => {
        console.error('POST Admin User ERROR: ', err);
        ToastStore.getNotifications().push({
          title: i18next.t('SORRY'),
          body: err.entity.error,
          level: 'error',
        });
        ToastStore.emitChange();
      },
    );
  },

  addCargomaticUser(user) {
    addCargomaticUser(user).then(
      () => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('NEW_SHIPPER_CREATED'),
          level: 'success',
        });
        ToastStore.emitChange();
      },
      (err) => {
        console.error('POST Cargomatic User ERROR: ', err);
        ToastStore.getNotifications().push({
          title: i18next.t('SORRY'),
          body: err?.entity?.message || i18next.t('SOMETHING_WENT_WRONG'),
          level: 'error',
        });
        ToastStore.emitChange();
      },
    );
  },

  addCarrier(carrier) {
    addCarrier(carrier).then(
      () => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('NEW_CARRIER_CREATED'),
          level: 'success',
        });
        ToastStore.emitChange();
      },
      (err) => {
        ToastStore.getNotifications().push({
          title: i18next.t('FAILED_WITH_EXCLAMATION'),
          body: err?.entity?.message || i18next.t('SOMETHING_WENT_WRONG'),
          level: 'error',
        });
        ToastStore.emitChange();
      },
    );
  },

  addConsignee(vendor) {
    addConsignee(vendor).then(
      () => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('NEW_CONSIGNEE_CREATED'),
          level: 'success',
        });
        ToastStore.emitChange();
      },
      (err) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: err?.entity?.message || i18next.t('SOMETHING_WENT_WRONG'),
          level: 'error',
        });
        ToastStore.emitChange();
      },
    );
  },

  addVendor(vendor) {
    addVendor(vendor).then(
      () => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('NEW_VENDOR_CREATED'),
          level: 'success',
        });
        ToastStore.emitChange();
      },
      (err) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: err?.entity?.message || i18next.t('SOMETHING_WENT_WRONG'),
          level: 'error',
        });
        ToastStore.emitChange();
      },
    );
  },

  addDriver(driver) {
    addDriver(driver).then(
      (res) => {
        if (res.entity.success) {
          ServerActions.createDriverSuccess(driver);
        } else {
          ServerActions.createDriverFail(res.entity.error);
        }
      },
      (err) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: err?.entity?.error || i18next.t('SOMETHING_WENT_WRONG'),
          level: 'error',
        });
        ToastStore.emitChange();
        ServerActions.createDriverFail(err.entity.error);
      },
    );
  },

  update(id, atts) {
    const success = (res) => {
      ServerActions.updateUserSuccess(res.entity);
    };
    const fail = (err) => {
      console.error('user update ERROR: ', err);
    };
    update(id, atts).then(success, fail);
  },

  updateNotificationEvent(id, data) {
    updateNotificationEvent(id, data).then(
      (res) => {
        AdminServerActionCreators.updateNotificationSuccess(res.entity.user);
      },
      (err) => {
        AdminServerActionCreators.updateNotificationFail(err);
      },
    );
  },

  updateNotificationRecipients(id, data) {
    updateNotificationRecipients(id, data).then(
      (res) => {
        AdminServerActionCreators.updateNotificationSuccess(res.entity.user);
      },
      (err) => {
        AdminServerActionCreators.updateNotificationFail(err);
      },
    );
  },
  getUserContextGrants(scopes) {
    return getUserContextGrants(scopes).then(
      (res) => {
        return res.entity.scopes;
      },
      (err) => {
        console.log('Failed to get user contexts ', err);
      },
    );
  },
  getUserContextGrantsByGrantee(grantorId, contexts) {
    return getUserContextGrantsByGrantee(grantorId, contexts).then(
      (res) => {
        return res.entity.scopes;
      },
      (err) => {
        console.log('Failed to get user contexts ', err);
      },
    );
  },
  getCustomers(params, options) {
    getCustomers(params, options).then(
      (res) => {
        AdminServerActionCreators.receiveCustomers(res.entity);
      },
      (res) => {
        AdminServerActionCreators.getCustomersFail(res.err || res);
      },
    );
  },

  downloadCustomersCsv(params, options) {
    downloadCustomersCsv(params, options).then(
      (response) => {
        // The response has a Content-Disposition header with a filename, but it must get trimmed out before this point.
        let csvFileName = `customers-${moment()
          .local()
          .format('MM-DD-YYYY-HH:mm:ss')}.csv`;
        fileDownload(response.entity, csvFileName);
      },
      (err) => {
        AdminServerActionCreators.downloadCustomersCsvFail(err);
      },
    );
  },

  async getAccountAccessRequests(id) {
    return getAccountAccessRequests(id)
      .then((result) => {
        return result.entity;
      })
      .catch((e) => {
        throw e;
      });
  },

  async createAccountAccessRequest(id, emails) {
    return createAccountAccessRequest(id, emails)
      .then((result) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS'),
          body: i18next.t('REQUEST_SENT'),
          level: 'success',
        });
        ToastStore.emitChange();
        return result.entity;
      })
      .catch((e) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SORRY'),
          body: e.entity.error,
          level: 'error',
        });
        ToastStore.emitChange();
        throw e;
      });
  },

  async createGrants(grantorId, granteeId, role, _type, userType) {
    return createGrants(grantorId, granteeId, role, _type, userType)
      .then((result) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('LOGIN_ACCESS_SUCCESS'),
          level: 'success',
        });
        ToastStore.emitChange();
        return result.entity;
      })
      .catch((e) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: i18next.t('LOGIN_ACCESS_GRANT_ERROR'),
          level: 'error',
        });
        ToastStore.emitChange();
        throw e;
      });
  },

  async revokeAdminPermission(
    grantorId,
    granteeId,
    role,
    _type,
    userType,
    revokeDate,
  ) {
    return revokeAdminPermission(
      grantorId,
      granteeId,
      role,
      _type,
      userType,
      revokeDate,
    )
      .then((result) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('REVOKED_REQUEST_SUCCESS'),
          level: 'success',
        });

        ToastStore.emitChange();
        return result.entity;
      })
      .catch((e) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: e.entity.error,
          level: 'error',
        });
        ToastStore.emitChange();
        throw e;
      });
  },

  async createSupportRequestGrant(id, email, grantorId) {
    return createSupportRequestGrant(id, email, grantorId)
      .then((result) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('SUPPORT_REQUEST_GRANTED'),
          level: 'success',
        });
        ToastStore.emitChange();
        return result.entity;
      })
      .catch((e) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: e.entity.error,
          level: 'error',
        });
        ToastStore.emitChange();
        throw e;
      });
  },

  async loginAs(userId, grantorId) {
    try {
      const scopes = await this.getUserContextGrants(['login']).catch((e) => {
        throw e;
      });

      const hasAccess = scopes?.login?.accounts?.find(
        (account) => account._id === grantorId,
      );

      if (!hasAccess) {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: i18next.t('USER_NO_SUPPORT_LOGIN_AS'),
          level: 'error',
        });
        ToastStore.emitChange();
        return;
      }
    } catch (e) {
      console.log('Error getting scopes: ', e);

      ToastStore.getNotifications().push({
        title: i18next.t('ERROR'),
        body: i18next.t('UNABLE_TO_GET_ACCESS_REQUIREMENTS'),
        level: 'error',
      });
      ToastStore.emitChange();
    }

    return loginAs(userId, grantorId)
      .then((result) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('LOGIN_AS_SUCCESS'),
          level: 'success',
        });
        ToastStore.emitChange();

        const { user, token } = result.entity.data;

        SessionStore.setAuthToken(token);
        SessionStore.storeUser(user);
        SessionStore.setLoginAs(user);
        return user;
      })
      .catch((e) => {
        console.log(e);

        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: e.entity.error,
          level: 'error',
        });
        ToastStore.emitChange();
        throw e;
      });
  },

  async createSupportRequest(id, email, grantorId) {
    return createSupportRequest(id, email, grantorId)
      .then((result) => {
        ToastStore.getNotifications().push({
          title: i18next.t('SUCCESS_WITH_EXCLAMATION'),
          body: i18next.t('REQUEST_SENT'),
          level: 'success',
        });
        ToastStore.emitChange();

        return result;
      })
      .catch((e) => {
        ToastStore.getNotifications().push({
          title: i18next.t('ERROR'),
          body: e.entity.error,
          level: 'error',
        });
        ToastStore.emitChange();
        throw e;
      });
  },

  findCarriers(query) {
    findCarriers(query).then(
      (res) => {
        return res.entity.users;
      },
      (err) => {
        console.log('Failed to get carriers', err);
      },
    );
  },

  updateBankingInfoStatus(
    carrierId,
    stripe_verified_documents,
    all_banking_info_approved,
    admin_banking_info_remark = '',
  ) {
    return new Promise((resolve, reject) => {
      updateBankingInfoStatus(
        carrierId,
        stripe_verified_documents,
        all_banking_info_approved,
        admin_banking_info_remark,
      ).then(
        (res) => {
          if (res.entity.success) {
            SessionStore.onCarrierUpdated({ carrier: res.entity.carrier });
            showToast({
              title: i18next.t('SUCCESS'),
              body: i18next.t('BANKING_INFO_UPDATED'),
              level: 'success',
            });
            resolve();
          } else if (res.entity.error) {
            throw new Error(res.entity.error);
          }
        },
        (err) => {
          console.log('Error in updating Banking Info Status', err);
          showToast({
            title: i18next.t('ERROR'),
            body: i18next.t('BANKING_INFO_ERROR'),
            level: 'error',
          });
          reject();
        },
      );
    });
  },

  getEmptyReturnInstructions() {
    return getEmptyReturnInstructions()
      .then((res) => {
        return {
          lastModifiedAt: res.headers['Last-Modified'],
          data: res.entity,
        };
      })
      .catch((e) => {
        console.log(e);
      });
  },
};
